import { useSelector } from 'react-redux';
import { selectUIConfig, selectFeatureFlags } from '../store/uiConfigSlice';

/**
 * A hook to access the UI configuration from any component
 * @returns UI configuration from the Redux store
 */
export const useUIConfig = () => {
  return useSelector(selectUIConfig);
};

/**
 * A hook to access feature flags from any component
 * @returns Feature flags from the Redux store
 */
export const useFeatureFlags = () => {
  return useSelector(selectFeatureFlags);
};

/**
 * Helper function to check if a specific feature is enabled
 * @param featureName The name of the feature to check in feature flags
 * @returns boolean indicating if the feature is enabled
 */
export const useIsFeatureEnabled = (featureName: string) => {
  const featureFlags = useSelector(selectFeatureFlags);
  
  if (!featureFlags || !featureFlags.features) {
    return true; // Default to enabled if feature flags are not available
  }
  
  // Check if feature exists in config and is explicitly set to false
  return !(featureName in featureFlags.features && featureFlags.features[featureName as keyof typeof featureFlags.features] === false);
};

/**
 * Get theme configuration from the UI config
 * @returns Theme configuration for the application
 */
export const useThemeConfig = () => {
  const uiConfig = useSelector(selectUIConfig);
  return uiConfig?.config;
};
